module.exports = __webpack_public_path__ + "img/cst_channel.f2ab26cb.svg";